import React from 'react';
import env from '@/env';
import Microapp from '@/components/micro-app';
import Container from '@/components/container';

/**
 * 0623-频道生态-经海路频道标签平台内嵌到营销中心
 * 频道标签管理列表【工作台营销工具入口跳入】
 * 入口可见权限：对所有ERP可见
 */
export default function TagManageList() {
  return (
    <Container>
      <Microapp
        destory={true}
        name="TagManageList"
        basename="/tag-manage-list/"
        baseroute="/tag-manage-list/"
        data={{
          baseroute: '/tag-manage-list/',
          modeType: 'list', // list：从首页点击进到的列表页
        }}
        // http://easylabel-dev.jd.com
        url={env.EASYLABELPLAT_DOMAIN + '/channel-label-production/channel-label-dev/home'}
      />
    </Container>
  );
}
